<template>
    <div class="blog-details-area ptb-100">
        <div class="container">
            <div class="row justify-content-center">
                <div class="col-lg-8 col-md-12">
                    <div class="blog-details-desc">
                        <div class="article-image">
                            <img src="../../assets/images/blog/preventive-dentistry/mouth-guards-main-page.webp" alt="image">

                        </div>

                        <div class="article-content">
                            <div class="row">
                                

                                <h2><u>{{ $t('blog_page_preventive_dentistry_splints_title') }}</u></h2>
                                <p>{{ $t('blog_page_preventive_dentistry_splints_p') }}</p>
                                <p>{{ $t('blog_page_preventive_dentistry_splints_p1') }}</p>
                            </div>

                            <div class="article-tag">
                                <span>Share:</span>
                                <a href="https://www.facebook.com/" target="_blank"><i class='bx bxl-facebook'></i></a>
                                <a href="https://twitter.com/?lang=en" target="_blank"><i class='bx bxl-twitter'></i></a>
                                <a href="https://www.linkedin.com/" target="_blank"><i class='bx bxl-linkedin'></i></a>
                                <a href="https://www.instagram.com/" target="_blank"><i class='bx bxl-instagram'></i></a>
                            </div>
                        </div>

                        
                    </div>
                </div>

               
                
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: 'PreventiveSportsSplints',
    
    
}
</script>


